module.exports = __webpack_public_path__ + "img/country5.fd142f73.jpg";